import { render, staticRenderFns } from "./WizardStepSlider.vue?vue&type=template&id=2678e366&"
import script from "./WizardStepSlider.vue?vue&type=script&lang=js&"
export * from "./WizardStepSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports